import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment.js';
import { trackTikTokEvent, trackPostHog } from '../utils/tracking.js';

export const trackSignIn = (method) => {
  const eventData = {
    auth_method: method,
    ...getEnvironmentData()
  };

  track('sign_in', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'sign_in',
        content_type: 'product',
        content_id: 'user_authentication'
      }
    ]
  };
  trackTikTokEvent('CompleteRegistration', tiktokEvent);

  trackPostHog('user_signed_in', eventData);

  // Google Ads conversion event
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17262541327/g-HbCJbf9eEaEI_0tadA'
    });
  }

  // Facebook Pixel conversion event
  if (typeof window.fbq !== 'undefined') {
    window.fbq('track', 'CompleteRegistration');
  }
};

export const trackSignOut = () => {
  const eventData = {
    ...getEnvironmentData()
  };

  track('sign_out', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'sign_out',
        content_type: 'product',
        content_id: 'user_signout'
      }
    ]
  };
  trackTikTokEvent('Logout', tiktokEvent);

  trackPostHog('user_signed_out', eventData);
}; 